import settings from '../settings';

import 'jquery-form';
import sweetalert from 'sweetalert';

export default class Avatar {

  constructor($elem) {
    this.$elem = $elem;
    this.init();
  }

  submit__post_image_upload(ev) {
    ev.preventDefault();

    // Stop the process if cancel is pressed
    if (! !! $('#profile-avatar__upload').val()) {
        return false;
    }

    var $self = $(ev.delegateTarget);
    var $elem = this.$elem;

    var options = {
      url: $self.attr('action'),
      error: function (response, status) {

        if (typeof(response.responseText) !== 'undefined') {
          xmlDoc = $.parseXML(response.responseText),
          $xml = $(xmlDoc),
          $code = $xml.find("Code");
          if ($code.text() == 'EntityTooLarge') {
            // Specific AWS complaint for image size
            sweetalert({
              title: 'Upload Error',
              text: 'Sorry, that image is too large. Images must be less than 3MB. Please try a different image.',
              type: 'error'
            });
          } else {
            // Other AWS complaint
            sweetalert({
              title: 'Upload Error',
              text: 'There was a problem uploading the image: ' . $xml.find('Message').text(),
              type: 'error'
            });
          }
        } else {
          // Catch call
          sweetalert({
            title: 'Upload Error',
            text: 'There was a problem uploading the image. Please try again, or use a different image. Images must be less than 3MB.',
            type: 'error'
          });
        }
      },
      success : function (response, status) {
          var image = $(response).find('Location').text();
          $elem.find("input[name='image']").val(image);

          $.ajax({
              url: $('#profile-avatar__form').data('avatar-url'),
              data: {"image": image},
              method: "post"
          });

          $("img.avatar").attr('src', image);

          sweetalert({
            title: 'Avatar uploaded',
            text: 'Your avatar has been updated',
            type: 'success'
          });

        }
    };

    $self.ajaxSubmit(options);

    return false;
  }

  init() {
    this.$elem
      .on('change', '#profile-avatar__upload', this.submit__post_image_upload.bind(this))
      .on('submit', '#profile-avatar__form', this.submit__post_image_upload.bind(this));
  }
}
